import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import THEME from '../../shared/theme';
import { SectionIcon, ForwardIcon } from '../../icons';
import FieldDescriptionButton from './field-description-button';

interface Props {
  expanded: boolean,
  onClick(): void,
  isDrillDown: boolean,
  label: string,
  description: string|null,
}

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  minHeight: 36,
  background: THEME.sectionTitleBackground,
  borderBottom: THEME.fieldBorderMedium,
  cursor: 'pointer',
  fontWeight: 'bold',

  ':hover': {
    background: THEME.sectionTitleBackgroundHover,
  },
});

const IconContainer = styled(Box)({
  borderRight: THEME.fieldBorderMedium,
  width: 37,
  height: 35, // this style is for IE10
  padding: 8,
  paddingBottom: 0,
  display: 'inline-block',
});

const Accessory = styled(Box)({
  float: 'right',
  marginRight: 12,
  paddingTop: 9,
  fontSize: 12,
  fontWeight: 'bold',
  verticalAlign: 'middle',
  display: 'inline-block',
});

const SectionLabel = styled(Box)({
  display: 'inline-block',
  paddingTop: 9,
  paddingLeft: 12,
  fontSize: 14,
});

const FormSectionTitle: React.FC<Props> = ({
  onClick,
  expanded,
  isDrillDown,
  label,
  description,
}: Props) => (
  <Container
    onClick={onClick}
    aria-hidden="true"
  >
    <IconContainer>
      <SectionIcon style={{ opacity: expanded ? 1 : 0.2 }} />
    </IconContainer>
    <Box sx={{ flexGrow: 1 }}>
      <SectionLabel>
        {label}
      </SectionLabel>
      {isDrillDown && (
        <Accessory>
          View
          <ForwardIcon style={{
            width: 16,
            height: 16,
            display: 'inline-block',
            verticalAlign: 'middle',
          }}
          />
        </Accessory>
      ) }
    </Box>
    { description
      ? (
        <FieldDescriptionButton
          backgroundColor={THEME.sectionTitleBackground}
          label={label}
          description={description}
        />
      )
      : null }
  </Container>
);

export default FormSectionTitle;
